import { Link } from "react-router-dom";

var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var CurrentUser = require("lib/account/CurrentUser");
var ImageIcon = require("components/utility/icons/ImageIcon");
var ReactTooltip = require("react-tooltip");

class CoinsNotificationContainer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			popoverOpen: false
		};
	}

	toggleCoinsData(e) {
		$wr.nope(e)
		if (this.state.popoverOpen) {
			this.setState({ popoverOpen: false });
		} else {

			$(".studentGoalDataWrapper").not(this.refs.wrapper).trigger("closePopover");
			Mycroft.newEvent({ category: "Navbar", action: "view-coin-history" });

			this.setState({ popoverOpen: true });
		}
	}

	animateCoins() {
		var $coinsContainer = $(this.refs.coinsContainer);
		$coinsContainer.hide().fadeIn();

		var driftScale = 160;

		var $coins = $coinsContainer.find(".displayCoin");

		$coins.finish().css({ top: 0, left: 0 }).show();

		setTimeout(function() {
			$coinsContainer.fadeOut();
		}, 1000); // Need to coordinate this w/ delay in CurrentUser

		$coins.each(function() {
			var speed = _.random(1000, 1500);
			var drift = Math.random() - 0.5;
			var randGroup = Math.random();

			if (randGroup < 0.333) {
				$(this).animate({
					top: 300,
					left: (driftScale * drift)
				}, speed);

			} else if (randGroup < 0.666) {
				$(this).animate({
					left: 300,
					top: 50 + (driftScale * drift),
				}, speed);

			} else {
				$(this).animate({
					left: -300,
					top: 50 + (driftScale * drift),
				}, speed);
			}
		});
	}

	render() {
		var currentUser = CurrentUser.get();
		if (this.state.popoverOpen) {
			if (currentUser.coin_records.length > 0) {
				var recordItems = _.map(currentUser.coin_records, function(coinRecord) {
					if (coinRecord.change >= 0) {
						var verb = "got";
						var icon = "coin";

					} else if (coinRecord.key && coinRecord.key.startsWith("reverse-")) {
						var verb = "lost";
						var icon = "student";
					} else {
						var verb = "spent";
						var icon = "student";
					}
					var reason = FeedbackFormatter.formatSimple(coinRecord.reason);
					return (
						<div className="coinNotificationItem clearfix" key={ coinRecord.id }>
							<p>
								<ImageIcon icon={ icon } className="itemCoin" />{" "}
								<strong>You { verb } { Math.abs(coinRecord.change) } coins: </strong><br />
								{ reason }
							</p>
						</div>
					);
				});
			} else {
				var emptyCoinRecords = [];
				for (var i = 0; i <=4; i++) {
					emptyCoinRecords.push(
						<div className="emptyCoinRow" key={ i }>
							<div className="emptyCoinImage"></div>
							<div className="emptyCoinText"></div>
						</div>
					)
				};

				var emptyRecordContainer = (
					<div className="emptyStateContainer">
						<p className="emptyText">
							Take a quiz to earn some coins!
						</p>
						{ emptyCoinRecords }
					</div>
				)
			}
			var popover = (
				<div className="popover fade in bottom">
					<div className="arrow"></div>
					<div className="popover-content">
						{ emptyRecordContainer }
						{ recordItems }
					</div>
				</div>
			)
		}

		var coins = [];
		for (var i = 0; i < 15; i++) {
			var className = "displayCoin";
			coins.push(<ImageIcon icon="coin" className={ className } key={ i } />);
		}

		return (
			<div className="coinsContainer studentGoalDataWrapper" ref="wrapper"
				onClick={this.toggleCoinsData}>
				<div className="totalDisplay" data-tip={ currentUser.coins } data-for="coin-toolip">
					<ImageIcon icon="coin" height={ 20 } />{" "}
				</div>
				<ReactTooltip place="bottom" effect="solid" id="coin-toolip" />
				<div className="animatedCoinsContainer" ref="coinsContainer">
					{ coins }
				</div>
				{ popover }
			</div>
		);
	}

	onDocumentClick(e) {
		var isChild = $(e.target).closest(this.refs.wrapper).length > 0;
		if (!isChild && this.state.popoverOpen) {
			this.setState({ popoverOpen: false });
		}
	}

	componentDidMount() {
		$(this.refs.wrapper).on("closePopover", function() {
			if (this.state.popoverOpen) {
				this.setState({ popoverOpen: false });
			}
		}.bind(this));

		if (window.wrNotifications == undefined) {
			window.wrNotifications = {};
		}
		window.wrNotifications.triggerCoinAward = this.animateCoins;

		$(window.document).on("click", this.onDocumentClick);
	}

	componentWillUnmount() {
		$(window.document).off("click", this.onDocumentClick);
	}
};

CoinsNotificationContainer.propTypes = StrictPropTypes({
});

module.exports = CoinsNotificationContainer;



// WEBPACK FOOTER //
// ./modules/components/notifications/CoinsNotificationContainer.js